const Widget = () => {
  return <div>request an unlock email</div>;
};

export default Widget;
